@if (onboarding.draft().agency; as agency) {
<div class="flex h-0 min-h-0 flex-1 flex-col gap-4">
  <div class="flex shrink-0 flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
      We found {{ agency.name }} 🎯
    </h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">This is your agency workspace. Confirm your currency, then add the brands you manage.</p>
  </div>

  <article class="flex h-0 min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-border bg-card shadow-lg">
    @if (agency.bannerUrl) {
      <img [src]="agency.bannerUrl" alt="" class="h-16 w-full shrink-0 object-cover lg:h-24" />
    } @else {
      <div class="h-16 shrink-0 bg-linear-to-br from-brand-deep-purple to-primary lg:h-24"></div>
    }
    <div class="flex shrink-0 items-center gap-3 px-5 pt-5">
      <div class="flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-lg border-4 border-card bg-linear-to-br from-brand-agency-dark to-brand-agency text-xl font-black text-white shadow-sm">
        @if (agency.logoUrl) {
          <img [src]="agency.logoUrl" alt="" class="size-14 object-contain" />
        } @else {
          {{ initial() }}
        }
      </div>
      <div class="min-w-0 flex-1">
        <p class="m-0 text-2xl font-bold text-foreground">{{ agency.name }}</p>
        @if (agency.domain) {
          <p class="m-0 text-base font-semibold text-muted-foreground">{{ agency.domain }}</p>
        }
      </div>
      <button type="button" class="btn-shout-fab-secondary shrink-0" (click)="edit()" aria-label="Edit agency">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="size-4" aria-hidden="true">
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
        </svg>
      </button>
    </div>

    <div class="h-0 min-h-0 flex-1 touch-pan-y overflow-y-auto overscroll-y-contain [-webkit-overflow-scrolling:touch]">
      <div class="flex flex-col gap-3 px-5 py-4">
        @if (agency.description) {
          <p class="m-0 text-lg font-medium text-muted-foreground" [class]="descriptionClass()">{{ agency.description }}</p>
          @if (showDescriptionToggle()) {
            <button type="button" class="self-start text-base font-bold text-primary" (click)="toggleDescription()">
              {{ descriptionOpen() ? 'Show less' : 'Show more' }}
            </button>
          }
        }
        <div class="flex flex-wrap gap-2">
          <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">Agency</p>
          @if (agency.socials.length) {
            <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">{{ agency.socials.length }} social channels</p>
          }
        </div>
      </div>
    </div>
  </article>

  <fieldset class="m-0 flex shrink-0 flex-col gap-2 border-0 p-0">
    <legend class="text-base font-bold">Operating currency</legend>
    <div class="grid grid-cols-3 gap-2">
      @for (currency of currencies; track currency) {
        <button
          type="button"
          class="h-12 rounded-lg border text-lg font-bold"
          [class]="onboarding.activeCurrency() === currency ? 'border-primary bg-primary text-primary-foreground' : 'border-border bg-card text-foreground'"
          (click)="chooseCurrency(currency)">
          {{ currency === 'GBP' ? '£ GBP' : currency === 'USD' ? '$ USD' : '€ EUR' }}
        </button>
      }
    </div>
    <p class="m-0 text-sm font-semibold text-muted-foreground">
      @if (currencyDetected()) {
        Detected from {{ agency.domain || 'your website' }}. Your brands' campaigns and wallets use this currency.
      } @else {
        Your brands' campaigns and wallets use this currency.
      }
    </p>
  </fieldset>

  <div class="fixed inset-x-0 bottom-0 z-20 shrink-0 border-t border-border bg-background px-5 py-3 lg:static lg:z-auto lg:border-t lg:px-0">
    <button type="button" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" (click)="continueToBrands()">
      Add your brands →
    </button>
    <button type="button" class="mt-3 w-full text-center text-base font-bold text-primary" (click)="reject()">This isn't my agency</button>
  </div>
</div>
}
